import { useGetImageTypeBanners } from '@/apis/rest/generated/hooks'
import { ImageTypeBannerAreaEnum } from '@/apis/rest/generated/types'
import ImageBannerSlider from '@/components/common/slider/ImageBannerSlider'
import { usePetType } from '@/containers/hooks'
import { makeProductDetailImageBanners } from '@/utils/banner.util'
import { FitpetMallEventEnum } from '@/utils/event-tracker/events'

type ProductDetailContentImageBannerProps = {
  id: number
  productName: string
}

export const ProductDetailContentImageBanner = ({ id, productName }: ProductDetailContentImageBannerProps) => {
  const { getPetType } = usePetType()
  const { data, isError } = useGetImageTypeBanners(
    { petType: getPetType(), area: [ImageTypeBannerAreaEnum.PDP_BAND] },
    { query: { select: (data) => makeProductDetailImageBanners(data, id, productName) } }
  )

  const eventTrackerName = {
    view: FitpetMallEventEnum.ViewProductdetailBanner,
    click: FitpetMallEventEnum.ClickProductdetailBanner,
  }

  if (!data || data.length === 0) return null

  return (
    <ImageBannerSlider
      banners={data}
      eventTrackerName={eventTrackerName}
      isError={isError}
      bannerStyles={{
        height: 50,
        logoWidth: 68,
      }}
    />
  )
}
